import { memo, useCallback, useMemo, useRef } from "react"

import { URL_ARRAY_PARAM_SEPARATOR } from "constants/constants"
import { usePaginationFromURL } from "hooks/usePaginationFromURL"

import { FilterPopover } from "components/FilterComponents/FilterPopover/FilterPopover"
import { FilterType } from "components/FilterComponents/FilterPopover/types"

import { OrderFilterKey, VALID_ORDER_STATUSES } from "../../constant"
import { createStatusFilterOptions } from "../../utils"

interface StatusFilterProps {
    isFree?: boolean
    handleUpdateParam: (paramName: string, paramValue: string) => void
}

export const StatusFilter = memo(({ isFree, handleUpdateParam }: StatusFilterProps) => {
    const { statuses } = usePaginationFromURL('orders')

    const statusesRef = useRef(statuses)
    const handleUpdateParamRef = useRef(handleUpdateParam)

    statusesRef.current = statuses
    handleUpdateParamRef.current = handleUpdateParam

    const statusOptions = useMemo(() =>
        createStatusFilterOptions(VALID_ORDER_STATUSES, isFree)
        , [isFree])

    const filterOptions = useMemo(() =>
        statusOptions.map(status => ({
            label: status.text,
            value: status.statuses
        }))
        , [statusOptions])

    const handleStatusChange = useCallback((value: string) => {
        const currentStatuses = statusesRef.current
        const newSelectedItems = currentStatuses.includes(value)
            ? currentStatuses.filter(item => item !== value)
            : [...currentStatuses, value]

        if (newSelectedItems.length === 0) {
            handleUpdateParamRef.current(OrderFilterKey.STATUSES, '')
            return
        }

        const encodedStatuses = encodeURIComponent(newSelectedItems.join(URL_ARRAY_PARAM_SEPARATOR))
        handleUpdateParamRef.current(OrderFilterKey.STATUSES, encodedStatuses)
    }, [])

    return (
        <FilterPopover
            label="Status"
            options={filterOptions}
            selectedItems={statuses}
            onChange={handleStatusChange}
            filterType={FilterType.CHECKLIST}
        />
    )
})